import { render, staticRenderFns } from "./OldParts.vue?vue&type=template&id=579b41d0&scoped=true&"
import script from "./OldParts.vue?vue&type=script&lang=js&"
export * from "./OldParts.vue?vue&type=script&lang=js&"
import style0 from "./OldParts.vue?vue&type=style&index=0&id=579b41d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579b41d0",
  null
  
)

export default component.exports